module.exports = __webpack_public_path__ + "static/media/refresh.9b98ac99.svg";